import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { IRole, IUser } from '@boma/administration-portal/shared/entities';
import { BreadcrumbService } from '@boma/ui';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { RolesFacade } from '../../../+state/roles/roles.facade';
import {
  addRoleUser,
  loadUserDetails,
  removeRoleUser,
  setSelectedUser,
} from '../../../+state/users/users.actions';
import { UsersFacade } from '../../../+state/users/users.facade';

@Component({
  selector: 'boma-users-detail',
  templateUrl: './users-detail.component.html',
  styleUrls: ['./users-detail.component.scss'],
})
export class UsersDetailComponent implements OnInit {
  user$: Observable<IUser>;
  roles$: Observable<IRole[]>;
  roles: any;
  id: string;
  displayAddRoleToUserDialog: boolean = false;
  roleToAdd: IRole;
  constructor(
    public usersFacade: UsersFacade,
    public rolesFacade: RolesFacade,
    private route: ActivatedRoute,
    private breadcrumbService: BreadcrumbService
  ) {
    this.breadcrumbService.setItems([{ label: 'Users - User' }]);
  }

  ngOnInit(): void {
    const params = this.route.snapshot.params;
    this.id = params.id;
    this.usersFacade.dispatch(loadUserDetails({ userId: params.id }));
    this.user$ = this.usersFacade.selectedUsers$.pipe(
      map((user) => {
        if (user) {
          this.rolesFacade.allRoles$.subscribe({
            next: (roles) => {
              this.roles = roles.filter(
                (role) => user.roles.map((r) => r.id).includes(role.id) == false
              );
            },
          });
          return user;
        }
      })
    );
  }

  addRoleToUser() {
    const roleToAdd = this.roleToAdd as IRole;
    this.usersFacade.dispatch(
      addRoleUser({ role: roleToAdd, userId: this.id })
    );
    this.displayAddRoleToUserDialog = false;
  }

  removeRoleFromUser(roleId: string) {
    this.usersFacade.dispatch(
      removeRoleUser({ roleId: roleId, userId: this.id })
    );
  }
}
